import { render } from "./NotificationBar.vue?vue&type=template&id=7072ccc7"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=7072ccc7&lang=css"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__